import {
  fetchCustomerOrderById,
  fetchCustomerOrderInvoices,
  type CustomerOrder,
  type CustomerOrderInvoice,
} from '../customerOrdersApi'
import { asOrderErrorMessage } from '../helpers/errors'

type DetailStateSetters = {
  setOrderDetail: (value: CustomerOrder | null) => void
  setOrderDetailError: (value: string) => void
  setOrderInvoices: (value: CustomerOrderInvoice[]) => void
  setOrderInvoicesError: (value: string) => void
}

export const resetOrderDetailState = (setters: DetailStateSetters) => {
  setters.setOrderDetail(null)
  setters.setOrderDetailError('')
  setters.setOrderInvoices([])
  setters.setOrderInvoicesError('')
}

export const applyOrderDetailError = (setters: DetailStateSetters, error: unknown) => {
  const message = asOrderErrorMessage(error)
  setters.setOrderDetail(null)
  setters.setOrderDetailError(message)
  setters.setOrderInvoices([])
  setters.setOrderInvoicesError(message)
}

export const fetchOrderDetailBundle = async ({
  token,
  orderDetailId,
}: {
  token: string | null | undefined
  orderDetailId: string
}): Promise<{ order: CustomerOrder; invoices: CustomerOrderInvoice[] }> => {
  const [order, invoices] = await Promise.all([
    fetchCustomerOrderById(token, orderDetailId),
    fetchCustomerOrderInvoices(token, orderDetailId),
  ])
  return { order, invoices }
}
